import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "./main.component";
import { ModuleWithProviders } from "@angular/core";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { UserManagementComponent } from "./user-management/user-management.component";
import { ViewUserComponent } from "./user-management/view-user/view-user.component";
import { AuthGuardMain } from "../auth/auth-guard.service";
import { AboutComponent } from "./about/about.component";
import { ContactComponent } from "./contact/contact.component";
import { CourseManagementComponent } from './course-management/course-management.component';
import { ViewCourseComponent } from './course-management/view-course/view-course.component';
import { EditCourseComponent } from './course-management/edit-course/edit-course.component';
import { AddCourseComponent } from './course-management/add-course/add-course.component';
import { PlanManagementComponent } from './plan-management/plan-management.component';
import { ViewPlanComponent } from './plan-management/view-plan/view-plan.component';
import { AddPlanComponent } from './plan-management/add-plan/add-plan.component';
import { EditPlanComponent } from './plan-management/edit-plan/edit-plan.component';
import { AddCourseDetailComponent } from './course-management/add-course-detail/add-course-detail.component';
import { ViewCourseDetailComponent } from './course-management/view-course-detail/view-course-detail.component';
import { EditCourseDetailComponent } from './course-management/edit-course-detail/edit-course-detail.component';
import { AddAsrComponent } from './course-management/add-asr/add-asr.component';
import { ViewAsrComponent } from './course-management/view-asr/view-asr.component';
import { GeneralConfigurationComponent } from './general-configuration/general-configuration.component';
import { EditConfigurationComponent } from './general-configuration/edit-configuration/edit-configuration.component';
import { NotificationComponent } from './notification/notification.component';
import { ViewUserCourseComponent } from './user-management/view-user-course/view-user-course.component';
import { ViewUserLessonComponent } from './user-management/view-user-lesson/view-user-lesson.component';
import { ViewUserASRComponent } from './user-management/view-user-asr/view-user-asr.component';
import { ReportedQuestionComponent } from './reported-question/reported-question.component';
import { EditAsrComponent } from './course-management/edit-asr/edit-asr.component';
import { ReportedDetailComponent } from './reported-question/reported-detail/reported-detail.component';
import { SubscriptionDetailComponent } from './user-management/subscription-detail/subscription-detail.component';
import { PartnerManagementComponent } from './partner-management/partner-management.component';
import { ViewPartnerComponent } from './partner-management/view-partner/view-partner.component';
import { AddPartnerComponent } from './partner-management/add-partner/add-partner.component';
import { EditPartnerComponent } from './partner-management/edit-partner/edit-partner.component';
import { EventManagementComponent } from "./event-management/event-management.component";
import { ViewEventComponent } from "./event-management/view-event/view-event.component";
import { AddEventComponent } from "./event-management/add-event/add-event.component";
import { EditEventComponent } from "./event-management/edit-event/edit-event.component";
import { ReportingManagementComponent } from "./reporting-management/reporting-management.component";
import { ViewComponent } from "./reporting-management/view/view.component";
import { DuplicateEventComponent } from "./event-management/duplicate-event/duplicate-event.component";
import { ChatSupportComponent } from "./user-management/chat-support/chat-support.component";
import { PastEventComponent } from "./event-management/past-event/past-event.component";
import { AuditlogComponent } from "./view-logs/auditlog/auditlog.component";
import { UserlogsComponent } from "./view-user-activity/userlogs/userlogs.component";
import { AdminTimelogsComponent } from "./view-logs/admin-timelogs/admin-timelogs.component";
import { ViewLogsComponent } from "./view-logs/view-logs.component";
import { ReportAnswerComponent } from "./reported-question/report-answer/report-answer.component";
import { ReportQuestionComponent } from "./reported-question/report-question/report-question.component";
import { QuestionDetailComponent } from "./reported-question/question-detail/question-detail.component";
import { MonitorLogsComponent } from "./view-user-activity/monitor-logs/monitor-logs.component";
import { ViewUserActivityComponent } from "./view-user-activity/view-user-activity.component";
import { ProviderManagementComponent } from "./provider-management/provider-management.component";
import { ViewProviderComponent } from "./provider-management/view-provider/view-provider.component";
import { AddProviderComponent } from "./provider-management/add-provider/add-provider.component";
import { EditProviderComponent } from "./provider-management/edit-provider/edit-provider.component";
import { OrganizationManagementComponent } from './organization-management/organization-management.component';
import { AddOrganizationComponent } from './organization-management/add/add.component';
import { ViewOrganizationComponent } from './organization-management/view/view.component';
import { BillerCodeComponent } from "./provider-management/biller-code/biller-code.component";
import { AddBillerComponent } from "./provider-management/add-biller/add-biller.component";
import { EditBillerComponent } from "./provider-management/edit-biller/edit-biller.component";
import { ProfileViewComponent } from "./organization-management/profile-view/profile-view.component";
import { UsersComponent } from "./reported-question/users/users.component";


export const routes: Routes = [
  {
    path: "main",
    component: MainComponent,
    children: [
      { path: "", redirectTo: "/main/dashboard", pathMatch: "full" },
      {
        path: "dashboard",
        component: DashboardComponent,
      },
      {
        path: "user-management",
        component: UserManagementComponent,
        children: [
          {
            path: "view-user", component: ViewUserComponent
          },
          {
            path: "auditlogs", component: AuditlogComponent
          },
          {
            path: "userlogs", component: UserlogsComponent
          },
          {
            path: "adminlogs", component: AdminTimelogsComponent
          },
          {
            path: "view-userCourse/:userId", component: ViewUserCourseComponent
          },
          {
            path: "view-userLesson/:userId", component: ViewUserLessonComponent
          },
          {
            path: "view-userASR/:userId", component: ViewUserASRComponent
          },
          {
            path: "subscription-detail/:userId", component: SubscriptionDetailComponent
          },
          {
            path: "chat-support/:userId", component: ChatSupportComponent
          },
        ],
      },
      {
        path: "course-management",
        component: CourseManagementComponent,
        children: [
          { path: "", redirectTo: "view-course", pathMatch: "full" },
          { path: "view-course", component: ViewCourseComponent },
          { path: "add-course", component: AddCourseComponent },
          { path: "edit-course/:course_Id", component: EditCourseComponent },
          { path: "add-courseDetail/:course_Id", component: AddCourseDetailComponent },
          { path: "view-lesson/:course_Id", component: ViewCourseDetailComponent },
          { path: "edit-courseDetail/:course_Id", component: EditCourseDetailComponent },
          { path: "add-asr/:course_Id", component: AddAsrComponent },
          { path: "view-asr/:course_Id", component: ViewAsrComponent },
          { path: "edit-asr/:course_Id", component: EditAsrComponent }
        ]
      },
      {
        path: "plan-management",
        component: PlanManagementComponent,
        children: [
          { path: "", redirectTo: "view-plan", pathMatch: "full" },
          { path: "view-plan", component: ViewPlanComponent },
          { path: "add-plan", component: AddPlanComponent },
          { path: "edit-plan/:plan_id", component: EditPlanComponent }
        ]
      },
      {
        path: "event-management",
        component: EventManagementComponent,
        children: [
          { path: "", redirectTo: "view-event", pathMatch: "full" },
          { path: "view-event", component: ViewEventComponent },
          { path: "past", component: PastEventComponent },
          { path: "add-event", component: AddEventComponent },
          { path: "edit-event/:event_id", component: EditEventComponent },
          { path: "duplicate-event/:event_id", component: DuplicateEventComponent }
        ]
        
      },
      {
        path: "partner",
        component: PartnerManagementComponent,
        children: [
          { path: "", redirectTo: "view", pathMatch: "full" },
          { path: "view", component: ViewPartnerComponent },
          { path: "add", component: AddPartnerComponent },
          { path: "edit/:partnerId", component: EditPartnerComponent }
        ]
      },
      {
        path: "provider",
        component: ProviderManagementComponent,
        children: [
          { path: "", redirectTo: "view", pathMatch: "full" },
          { path: "view", component: ViewProviderComponent },
          { path: "add", component: AddProviderComponent },
          // { path: "billercode", component: BillerCodeComponent },
          // { path: "add-billercode", component: AddBillerComponent },
          { path: "edit/:providerId", component: EditProviderComponent },
          // { path: "editbiller/:providerId", component: EditBillerComponent }
        ]
      },
      {
        path: "reporting",
        component: ReportingManagementComponent,
        children: [
          { path: "", redirectTo: "view", pathMatch: "full" },
          { path: "view", component: ViewComponent }
        ]
      },
      {
        path: "organization",
        component: OrganizationManagementComponent,
        children: [
          { path: "", redirectTo: "view", pathMatch: "full" },
          { path: "view", component: ViewOrganizationComponent},
          { path: "add", component: AddOrganizationComponent },
          { path: "profile", component: ProfileViewComponent},
        ]
      },
      {
        path: "logs",
        component: ViewLogsComponent,
        children: [
          { path: "", redirectTo: "admin", pathMatch: "full" },
          { path: "admin", component: AuditlogComponent },
          { path: "reporting", component:AdminTimelogsComponent  },
        ]
      },
      {
        path: "user-logs",
        component: ViewUserActivityComponent,
        children: [
          { path: "", redirectTo: "time", pathMatch: "full" },
          { path: "time", component: UserlogsComponent },
          { path: "monitor", component:MonitorLogsComponent  }
        ]
      },
      {
        path: "report",
        component: ReportedQuestionComponent,
        children: [
          { path: "", redirectTo: "answere", pathMatch: "full" },
          { path: "answere", component: ReportAnswerComponent },
          { path: "question", component:ReportQuestionComponent  },
          { path: "report-detail/:id", component: ReportedDetailComponent },
          { path: "report-detail-question/:id", component: QuestionDetailComponent },
          {path: "user" , component: UsersComponent}
        ]
      },
      { path: "about", component: AboutComponent },
      { path: "general", component: GeneralConfigurationComponent },
      { path: "general-edit", component: EditConfigurationComponent },
      { path: "notification", component: NotificationComponent },




      {
        path: "contact",
        component: ContactComponent,
      }
    ]
  }
];

export const routing: ModuleWithProviders = RouterModule.forChild(routes);
